// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { media } from '@toggl/style'

import { SectionBlock } from './SectionBlock'

export const SectionMobileNoBleedBlock = styled<
  React.ElementConfig<typeof SectionBlock>
>(SectionBlock)`
  padding: 0;
  ${media.mq[1]} {
    padding: 60px 30px;
  }
  ${media.mq[2]} {
    padding-bottom: 75px;
  }
`
